import { IBarcodeObject, IBarcodeItem } from "../../../../../../domain/editableFormat/objects";
import { IBarcodeObjectBean } from "../../../beans/objects";
import { IBarcodeItemBean } from "../../../beans/objects/items";
import { ItemsTranslator } from "./ItemsTranslator";

export class BarcodeItemsTranslator {
  from(bean: IBarcodeObjectBean): IBarcodeItem[] {
    return this.items.from(
      bean.barcodeitem,
      s => {
        const isHisItem = s["@name"] && (0 < s["@name"].length);
        return {
          isHisItem,
          value: isHisItem ? s["@name"] : s["@text"],
        };
      });
  }

  to(object: IBarcodeObject): IBarcodeItemBean | IBarcodeItemBean[] {
    return this.items.to(
      object.items,
      s => ({
        "@name": s.isHisItem ? s.value : "",
        "@text": s.isHisItem ? undefined : s.value,
      }),
    );
  }

  private readonly items = new ItemsTranslator();
}
